import React from "react";
import PromptComponent from "./prompt.component";
const PlaygroundContainer = () => {
  return <PromptComponent />;
};

export default PlaygroundContainer;
